export default __webpack_public_path__ + "static/media/Rectangle 3464676.8c854d03.svg";